import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link, } from 'react-router-dom';
import { PERMISSIONS } from '../../utils/constants';
import { isWebMobile } from '../../utils/util';
import $ from 'jquery';
import M from 'materialize-css/dist/js/materialize';
import Menu from '../Menu/Menu';
import { checkPermission } from '../../services/auth';
import Logo from '../../assets/images/logo_logistics.png';
import NetworkStatus from '../NetworkStatus/NetworkStatus';
import MessageService from '../../services/MessageService';
import './header.css';

const Header = (props) => {
    useEffect(() => {
        const elems = $('.dropdown-trigger');
        M.Dropdown.init(elems);

        if (checkPermission(PERMISSIONS.DigitalTracking.AlertShipment)) {
            props.getNotifications(props.user.vision, { read: false }, {});
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div id="header" style={{ position: 'fixed', top: '0', width: '100%', zIndex: '9999' }}>
            <nav id='navHeadres' className="z-depth-1">
                <div className="nav-wrapper">
                    <a href="#link" data-target="slide-out" className="sidenav-trigger show-on-large">
                        <i className="material-icons">menu</i></a>
                    <span className="brand-logo " style={{ left: isWebMobile() ? '36%' : '' }}>
                        <img className="brand-logo-img"
                            src={Logo}
                            height={isWebMobile() ? 30 : 38}
                            alt="Logistics PWA"
                            style={{ verticalAlign: 'middle' }} />
                    </span>
                    <span className="right second-text-color center" style={{ padding: '0px 5px', verticalAlign: 'middle' }}>
                        <NetworkStatus />
                    </span>
                    {
                        checkPermission(PERMISSIONS.DigitalTracking.AlertShipment) &&
                        <span className="right second-text-color center" style={{ padding: '0px 5px', verticalAlign: 'middle' }}>
                            <Link
                                key={`dpl-01`}
                                to={{ pathname: '/listNotifications' }}
                            >
                                <i className="mdi mdi-bell" title="Notifications" style={{ float: 'left', color: 'var(--second-text-color)' }} />
                                {
                                    props.totalMessages > 0 && (<span className="badge badge-danger">{props.totalMessages}</span>)
                                }
                            </Link>
                        </span>
                    }
                    <Menu />
                </div>
            </nav>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        totalMessages: state.messageReducer.totalMessages,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNotifications: (vision, filter, pagination) => {
            dispatch(MessageService.GetNotifications(vision, filter, pagination));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)((Header)));